import actionTypes from 'SRC/modules/redux/actionTypes'

export const setAdditionalDependenciesVisibility = visibility => ({
  type: actionTypes.SET_CATEGORY_ADDITIONAL_DEPENDENCIES_VISIBILITY,
  payload: visibility
})
